<template>
    <div class="text-center py-5" >
        <h2 class="title pb-4 display-4"><span class="fredericka text-black">Current</span> Events</h2>
        <b-container>
            <b-row>
                <b-col cols="12">
                    <div class="tagembed-widget" style="width:100%;height:100%" data-widget-id="2138629" data-tags="false"  view-url="https://widget.tagembed.com/2138629"></div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    methods: {
        appendTagembed () {
            const recaptchaScript = document.createElement('script');
            // Copied from tagembed code
            recaptchaScript.setAttribute('src', 'https://widget.tagembed.com/embed.min.js');
            
            document.head.appendChild(recaptchaScript);

            // Immediately removes child to prevent duplicate script tags on route changes
            // We only need to load this script once per page load
            document.head.removeChild(recaptchaScript);
        },
    },
    mounted () {
        this.appendTagembed();
    },
   
}
</script>

<style  lang="scss" scoped>
.fredericka {
    font-family: 'Fredericka the Great', cursive;
    color: #212529;
}
</style>